import React from "react";
import Select from "react-select";

const BusinessFieldSelection = ({
  onChange,
  options,
  error,
  selectedFields,
  padding = 4,
  disable = false,
}) => {
  const handleChange = (selectedOptions) => {
    onChange(selectedOptions);
  };

  // useEffect(() => {}, []);

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Lĩnh vực kinh doanh<span className="text-red-500"> *</span>
      </label>
      <Select
        options={options}
        isMulti
        isDisabled={disable}
        value={selectedFields}
        onChange={handleChange}
        className="react-select-container"
        classNamePrefix="react-select"
        noOptionsMessage={() => "Không có lựa chọn"}
        placeholder="Chọn"
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "8px",
            padding: `${padding}px`,
            borderColor: error ? "rgb(240 128 128)" : "rgb(209 213 219)",
            boxShadow: "none",
            "&:hover": {
              borderColor: "rgb(209 213 219)",
            },
          }),
        }}
      />
    </div>
  );
};

export default BusinessFieldSelection;
